var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00081 0.438028L1.21144 5.2274C1.12021 5.31844 1.06402 5.43891 1.05307 5.56737L0.876985 7.65621C0.863938 7.80887 0.915648 7.96 1.01955 8.07266C1.12335 8.18542 1.26983 8.24922 1.42306 8.24875H1.45715L3.58826 8.11218H3.58836C3.72111 8.10409 3.84634 8.04771 3.94062 7.95381L8.72852 3.16591C9.01033 2.8842 9.1686 2.50212 9.1686 2.10369C9.1686 1.70533 9.01032 1.32315 8.72852 1.04157L8.12094 0.438077C7.83952 0.157516 7.4583 0 7.06081 0C6.6634 0 6.28218 0.157514 6.00079 0.438077L6.00081 0.438028ZM3.31247 7.03636L2.01816 7.11826L2.12463 5.85813L5.69356 2.28945L6.87587 3.47176L3.31247 7.03636ZM7.95434 2.39449L7.64711 2.70172L6.4648 1.51941L6.77203 1.21218C6.84889 1.13542 6.95298 1.09237 7.06154 1.09237C7.17001 1.09237 7.2741 1.13542 7.35095 1.21218L7.95444 1.81567L7.95435 1.81557C8.0311 1.89243 8.07415 1.99652 8.07415 2.10508C8.07415 2.21355 8.03111 2.31764 7.95435 2.39449L7.95434 2.39449Z",
    fill: "#53A2B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5124 9.35352H0.546056H0.546151C0.35102 9.35352 0.170755 9.4576 0.0731387 9.62654C-0.0243796 9.79558 -0.0243796 10.0037 0.0731387 10.1727C0.170752 10.3416 0.351017 10.4457 0.546151 10.4457H10.5125H10.5124C10.7076 10.4457 10.8878 10.3416 10.9854 10.1727C11.083 10.0037 11.083 9.79557 10.9854 9.62654C10.8878 9.4576 10.7076 9.35352 10.5124 9.35352Z",
    fill: "#53A2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draft-icon.59a7a69ae9307949e98754d91b9dfcad.svg";
export { ForwardRef as ReactComponent };